import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { URL } from '../../constants'
import { searchAPI } from '../../services/api/search'
import { SearchSubscriptionListProps } from '../../types/interface'
import { getCookie } from '../../utils/common'
import DeleteModal from '../UI/DeleteModal'
import { removeHtmlTags } from '../Common/Common'


const ListUI = ({list, styles, getSubscriptionList}: SearchSubscriptionListProps) => {

    const [selectedUUID, setSelectedUUID] = useState('')
    const [selectedName, setSelectedName] = useState('')
    const [status, setStatus] = useState('')
    const [error, setError] = useState('')

    const deleteHandler = () => {
        setError('')
        setStatus('')
        if(status === 'progress') return
        
        setStatus('progress')

        const tenantSlug = getCookie('current_tenant')
        searchAPI(tenantSlug).remove?.(selectedUUID)
            .then((response) => {
                setStatus('success')
                setTimeout(() => {
                    cancelHandler()
                }, 3000);
            })
            .catch(err => {
                setStatus('failed')
                setTimeout(() => {
                    setStatus('')
                }, 3000);
                setError('Something went wrong. Please try again later.')
                console.log(err);
            })
    }

    const cancelHandler = (e?: React.MouseEvent<HTMLButtonElement>) => {
        setSelectedUUID('')
        setSelectedName('')
        setStatus('')
        if(!e) {
            const cancelModal = document.getElementById('deleteModal')?.querySelectorAll('.dismiss-deleteModal')[0] as HTMLButtonElement;
            cancelModal.click()
            getSubscriptionList()
        }
    }

    const setSelected = (uuid: string, name: string) => {
        setSelectedUUID(uuid)
        setSelectedName(name)
    }

    const listUI = list.length > 0 && list.filter(bucket => bucket.total_conversations).map(({uuid, name, total_conversations}) => {
        name = removeHtmlTags(name)
        return (
            <div key={uuid} className={`col-sm-6 col-md-4 col-xl-3 mb-4 ${styles.subscriptionItem}`}>
                <Link to={uuid} key={uuid} className="text-decoration-none">
                    <div className={`${styles.ListContainer} bg-white p-3`}>
                        <p className={styles.ConversationsCount}>{total_conversations}</p>
                        <h5>{name}</h5>
                    </div>
                </Link>
                <div className={styles.ListAction}>
                    <i className="bi bi-three-dots-vertical" data-bs-toggle="dropdown"></i>
                    <ul className="dropdown-menu">
                        <li>
                            <Link to={`${URL.search}/${uuid}`} className={`dropdown-item ${styles.dropdownItem}`}>EDIT</Link>
                            <span 
                                className={`dropdown-item ${styles.dropdownItem}`}
                                data-bs-toggle="modal" 
                                data-bs-target="#deleteModal" 
                                onClick={() => setSelected(uuid, name)}>DELETE
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        )
    })

    return (
        <>
            {listUI}
            {
                <DeleteModal
                    cancelHandler={cancelHandler}
                    deleteHandler={deleteHandler}
                    status={status}
                    content={<h6>{selectedName}</h6>}
                /> 
            }
        </>
    )
}

export default ListUI
